import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../layout/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('../views/home/index.vue')
      },
      {
        path: 'mine',
        name: 'mine',
        component: () => import('../views/mine/index.vue')
      },
      {
        path: 'contact',
        name: 'contact',
        component: () => import('../views/contact/index.vue')
      }
    ]
  },
  {
    path: '/publish',
    component: () => import('../views/publish/index.vue'),
    redirect: '/publish/video',
    children: [
      {
        path: 'video',
        name: 'publishVideo',
        component: () => import('../views/publish/video/index.vue')
      },
      {
        path: 'image-text',
        name: 'publishImageText',
        component: () => import('../views/publish/image-text/index.vue')
      },
      {
        path: 'draft',
        name: 'publishDraft',
        component: () => import('../views/publish/draft/index.vue')
      },
      {
        path: 'published',
        name: 'publishPublished',
        component: () => import('../views/publish/published/index.vue')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
